import React, { useEffect, useState } from 'react'
import 'react-phone-input-2/lib/bootstrap.css';
import PhoneInput from 'react-phone-input-2';
import { useDispatch, useSelector } from 'react-redux'
import { addContactAPI } from '../features/AddContactSlice'
function ContactUsForm() {
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});   // ✅ ADD THIS LINE
    const [showMessage, setShowMessage] = useState(false);
    // const [message, setMessage] = useState('');
    const dispatch = useDispatch();
    const { successMessage, error } = useSelector((state) => state.addContact);
    // const data = useSelector((state) => state.addContact);

    // console.log("submitted form data  is here ----->",successMessage)

    async function submit_ContactForm(e) {
        e.preventDefault();

        const newErrors = {};  // 🛠 Collect all field errors here
        const badInputRegex = /<[^>]*>|[:;]|(script|iframe|onerror|onload|style|img)/i;

        if (!name.trim()) {
            newErrors.name = 'Please enter the name';
        }
        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = 'Please enter a valid email';
        }
        if (!mobile || mobile.length < 10 || mobile.length > 20) {
            newErrors.mobile = 'Please enter a valid mobile number';
        }
        if (!description.trim()) {
            newErrors.description = 'Please enter the description';
        } else if (badInputRegex.test(description)) {
            newErrors.description = 'Description must not contain invalid characters or dangerous content.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // If no errors, proceed
        try {
            const res = await dispatch(addContactAPI({ name, mobile, email, description }));

            if (res?.payload?.success) {
                setShowMessage(true);
                setName('');
                setMobile('');
                setEmail('');
                setDescription('');
                setErrors({});  // Clear errors
            }
        } catch (error) {
            console.error('Form submission failed:', error);
        }
    }



    useEffect(() => {
        if (successMessage || error) {
            setShowMessage(true);
            // Hide message after 3 seconds
            const timer = setTimeout(() => {
                setShowMessage(false);
            }, 3000);
            // Cleanup function to clear the timer
            return () => clearTimeout(timer);
        }
    }, [successMessage, error]);

    // console.log("message -----> ",successMessage)
    // console.log("error-----> ",error)
    return (
        <div>
            <div className="contact-style-one-area overflow-hidden default-padding">
                <div className="contact-shape" style={{ zIndex: 1 }}>
                    <img title='Microcode Software' src="static/img/illustration/14.png" alt="Img Not Found" />
                </div>
                <div className="container">
                    <div className="row align-center">
                        <div className="contact-stye-one col-lg-5 mb-md-50 mb-xs-40">
                            <div className="contact-style-one-info">
                                <h4 className="sub-title">Get in Touch Today</h4>
                                <h2>Your Success Is Just a Click Away</h2>
                                <p>Get in touch with us today for expert support and customize solutions designed to fit your unique needs. Let’s collaborate to turn your goals into reality!</p>
                                <ul>
                                    <li className="wow fadeInUp" data-wow-delay="300ms">
                                        <div className="icon"><i className="fas fa-phone-alt"></i></div>
                                        <div className="content">
                                            <h5 className="title">Contact Number</h5>
                                            <p><a href="tel:+918882581143">+91-888-258-1143</a></p>
                                            <p><a href="tel:+18444170888">+1-844-417-0888</a></p>
                                        </div>
                                    </li>
                                    <li className="wow fadeInUp" data-wow-delay="300ms">
                                        <div className="icon">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div className="info">
                                            <h5 className="title">Our Location</h5>
                                            <p>Delhi, India</p>
                                            <p>Texas, USA</p>
                                        </div>
                                    </li>
                                    <li className="wow fadeInUp" data-wow-delay="500ms" >
                                        <div className="icon">
                                            <i className="fas fa-envelope-open-text"></i>
                                        </div>
                                        <div className="info">
                                            <h5 className="title">Official Email</h5>
                                            <p> <a href="mailto:contact@microcode.email">contact@microcode.email</a></p>
                                            <p><a href="mailto:info@microcodesoftware.com">info@microcodesoftware.com</a></p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="contact-stye-one col-lg-7 pl-60 pl-md-15 pl-xs-15">
                            <div className="contact-form-style-one">
                                <h2 className="heading">Send us a Message</h2>
                                <form>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            {errors && errors.name && <div style={{ color: 'red' }}>{errors.name}</div>}
                                            <div className="form-group">
                                                <input
                                                    className="form-control"
                                                    id="name"
                                                    name="name"
                                                    placeholder="Name"
                                                    type="text"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            {errors && errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
                                            <div className="form-group">
                                                <input
                                                    className="form-control"
                                                    id="email"
                                                    name="email"
                                                    placeholder="Email*"
                                                    type="text"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            {errors && errors.mobile && <div style={{ color: 'red' }}>{errors.mobile}</div>}
                                            <div className="form-group">
                                                <PhoneInput
                                                    country={'in'}
                                                    value={mobile}
                                                    onChange={(value) => setMobile(value)}
                                                    inputClass="form-control"
                                                    inputStyle={{ width: '100%' }}
                                                    containerStyle={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            {errors && errors.description && <div style={{ color: 'red' }}>{errors.description}</div>}
                                            <div className="form-group comments">
                                                <textarea
                                                    className="form-control"
                                                    id="comments"
                                                    name="comments"
                                                    placeholder="Tell Us About Project *"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <button onClick={submit_ContactForm} type="submit" name="submit" id="submit">
                                                <i className="fa fa-paper-plane" /> Get in Touch
                                            </button>
                                        </div>
                                    </div>

                                    {/* Alert Message */}
                                    {showMessage && (
                                        <div
                                            className="overlay_message_curd_1_my"
                                            style={{
                                                borderLeftColor: successMessage ? "#50d050" : "#f44336",
                                                animation: 'slideIn 0.5s ease forwards, fadeOut 0.5s ease 2.5s forwards'
                                            }}
                                        >
                                            <div className="content_1_my">
                                                <div
                                                    className="icon-circle"
                                                    style={{
                                                        borderColor: successMessage ? "#50d050" : "#f44336",
                                                        color: successMessage ? "#50d050" : "#f44336"
                                                    }}
                                                >
                                                    {successMessage ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}
                                                </div>
                                                <p className="message-type_1_my">
                                                    {successMessage ? successMessage : error}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ContactUsForm